<template>
    <generic-page>
        <div class="mb-2">
            <b-btn
                variant="link"
                size="lg"
                class="pl-0"
                to="/affiliate/reports"
            >
                <font-awesome-icon
                    size="lg"
                    icon="fa-light fa-chevron-left"
                />
                Reports
            </b-btn>
        </div>

        <div
            class="d-flex align-items-center justify-content-between mb-3 mt-2"
        >
            <h5 class="mb-0">{{ $t("Sales report") }}</h5>
            <b-form-select
                v-model="monthsWindow"
                :options="windowOptions"
                size="sm"
                style="width: auto"
            />
        </div>

        <div v-if="loading">
            <generic-loading />
        </div>
        <div v-else>
            <b-table-simple striped small responsive class="mb-0">
                <thead>
                    <tr>
                        <th>{{ $t("Month") }}</th>
                        <th class="text-right">{{ $t("Earnings") }}</th>
                        <th class="text-right">{{ $t("Signups") }}</th>
                        <th class="text-right">{{ $t("Buyers") }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="row in rollup" :key="row.ym">
                        <td class="align-middle">{{ formatMonth(row.ym) }}</td>
                        <td class="align-middle text-right">
                            {{ formatUsd(row.earningsUsd) }}
                        </td>
                        <td class="align-middle text-right">
                            {{ row.signups }}
                        </td>
                        <td class="align-middle text-right">
                            {{ row.newBuyers }}
                        </td>
                    </tr>
                </tbody>
            </b-table-simple>

            <div class="d-flex justify-content-end mt-2">
                <b-btn
                    v-if="copied"
                    variant="success"
                    size="sm"
                    disabled
                >
                    <font-awesome-icon icon="fa-light fa-check" />
                    {{ $t("Copied — paste into Excel") }}
                </b-btn>
                <b-btn
                    v-else
                    variant="outline-primary"
                    size="sm"
                    :disabled="!rollup.length"
                    @click="copyTable"
                >
                    <font-awesome-icon icon="fa-light fa-copy" />
                    {{ $t("Copy for Excel") }}
                </b-btn>
            </div>
        </div>
    </generic-page>
</template>

<script>
import copy from "clipboard-copy";

export default {
    data() {
        return {
            loading: false,
            monthsWindow: 6,
            windowOptions: [
                { value: 6, text: "6 mo" },
                { value: 12, text: "1 yr" },
                { value: 24, text: "2 yr" },
            ],
            rollup: [],
            copied: false,
            copiedTimer: null,
        };
    },
    created() {
        this.loadReport();
    },
    beforeDestroy() {
        if (this.copiedTimer) {
            clearTimeout(this.copiedTimer);
        }
    },
    watch: {
        monthsWindow() {
            this.loadReport();
        },
    },
    methods: {
        loadReport() {
            this.loading = true;

            this.api
                .post("/affiliate/reports/sales", {
                    months: this.monthsWindow,
                })
                .then((response) => {
                    if (response?.data?.rollup) {
                        this.rollup = response.data.rollup;
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        formatMonth(ym) {
            return this.$date(`${ym}-01`).format("MMM 'YY");
        },
        formatUsd(value) {
            return `$${Math.round(Number(value) || 0).toLocaleString()}`;
        },
        copyTable() {
            // TSV (tab-separated) — Excel auto-splits across cells on paste, and
            // raw numeric values (no $ / no commas) land as numbers, not text,
            // so the affiliate can sum/sort/filter without cleanup.
            const headers = ["Month", "Earnings (USD)", "Signups", "Buyers"];
            const rows = this.rollup.map((row) => [
                row.ym,
                Math.round(Number(row.earningsUsd) || 0),
                row.signups,
                row.newBuyers,
            ]);
            const tsv = [headers, ...rows]
                .map((cols) => cols.join("\t"))
                .join("\n");

            copy(tsv);

            this.copied = true;
            if (this.copiedTimer) {
                clearTimeout(this.copiedTimer);
            }
            this.copiedTimer = setTimeout(() => {
                this.copied = false;
                this.copiedTimer = null;
            }, 3000);
        },
    },
};
</script>
